import { motion } from "framer-motion";

const L = ({ top, size, ls = "0", italic, weight = 500, color = "#8a6b35", children, testid }) => (
  <div
    className="hline f-corm"
    data-testid={testid}
    style={{ top, fontSize: size, letterSpacing: ls, fontStyle: italic ? "italic" : "normal", fontWeight: weight, color }}
  >
    {children}
  </div>
);

export const HeroSection = () => (
  <motion.section
    className="hero-wrap snap-sec"
    data-testid="hero-section"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 1.2 }}
  >
    <div className="hero-card" style={{ backgroundImage: "url(/assets/blank_hero.png)" }}>
      <L top="18.0%" size="2.6cqw" ls="0.35em" color="#7a6034">PLEASE JOIN US FOR THE</L>
      <L top="22.8%" size="3.8cqw" ls="0.14em" weight={600} testid="function-name">GOL DHANA &amp;</L>
      <L top="26.2%" size="3.8cqw" ls="0.14em" weight={600}>ENGAGEMENT CEREMONY</L>
      <L top="29.8%" size="2.1cqw" ls="0.22em" color="#7a6034">TO CELEBRATE THE NEW BEGINNING OF</L>
      <L top="39.2%" size="4.4cqw" italic weight={600} testid="couple-names">Nikhil Ahuja &amp; Parita Jagad</L>
      <L top="45.0%" size="2.2cqw" ls="0.42em" color="#7a6034">SAVE THE DATE</L>
      <L top="49.6%" size="5.4cqw" italic weight={700} color="#8a6b35" testid="event-date">Sunday, 2 August 2026</L>
      <L top="54.4%" size="3.4cqw" ls="0.24em" weight={600} color="#6d5730" testid="event-time">6:00 PM ONWARDS</L>
      <div className="scroll-hint f-corm" data-testid="scroll-hint">SCROLL &#8595;</div>
    </div>
  </motion.section>
);
